import { useEffect } from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import { Services, AdditionalServices, WhyUs, Process, Portfolio, Testimonials } from "../components/site/Sections";
import EstimateForm from "../components/site/EstimateForm";
import Footer from "../components/site/Footer";
import useReveal from "../hooks/useReveal";

export default function Landing() {
  useReveal();

  useEffect(() => {
    document.title = "Cresta Bath & Tile · Premium Bathroom Renovations in Ottawa";
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#0A0A0A] text-[#F5F5F0] min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <AdditionalServices />
        <WhyUs />
        <Process />
        <Portfolio />
        <Testimonials />
        <EstimateForm />
      </main>
      <Footer />
    </div>
  );
}
